import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';



const PrivateRoute = ({ children }) => {
    return (
        isAuthenticated() ? (
            children
        ) : (
            <Navigate
                to= "/signin"
            />
        )
    )
}


export default PrivateRoute;